import React, { memo, useCallback, useEffect, useState } from "react";
import { TableSessionType, UserPlan } from "../constants/enum";
import { useMutation, useQueryClient } from "react-query";

import Cookies from "js-cookie";
import { CountdownComponent } from "./Countdown";
import { ITable } from "../types/TakuTypeSettei";
import { ModalSettingTable } from "./ModalSettingTable";
import StaffComponent from "./Staff";
import { StaffType } from "../types/StaffType";
import classNames from "classnames";
import { handleErrorMessage } from "utils/helper/common";
import moment from "moment";
import { queryKeys } from "../constants/constans";
import styles from "./styles.module.scss";
import { updateTableStep } from "../api/tableSession";
import useIsMobile from "../hooks/useIsMobile";
import useNetworkStatus from "hooks/useNetworkStatus";

export const Taku = memo((props: ITable) => {
  const { id, infoTable, isLoading } = props;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [stepOfCourse, setStepOfCourse] = useState<number>(0);
  const queryClient = useQueryClient();
  const [overtime, setOverTime] = useState<boolean>(false);
  const [lostTime, setLostTime] = useState<boolean>(false);
  const isOnline = useNetworkStatus();
  const { isMobile } = useIsMobile();
  const userPlan = Cookies.get("userPlan");

  const updateStepOfTableAction = useMutation(updateTableStep);

  const ShowModal = useCallback(() => setShowModal(true), []);

  useEffect(() => {
    if (!!infoTable) {
      const infoCurrentStep = infoTable?.stepInfos?.find(
        (item: any) => item?.step === infoTable?.step
      );
      setOverTime(
        !infoCurrentStep?.time ? false : Number(infoCurrentStep?.time) < 0
      );

      setLostTime(
        !infoCurrentStep?.time
          ? false
          : Number(infoCurrentStep?.time) > 0 &&
              Number(infoCurrentStep?.time) <
                Number(infoTable?.tableConfig?.intervalTime) * 60
      );
      setStepOfCourse(infoTable?.step);
    } else {
      setOverTime(false);
      setLostTime(false);
      setStepOfCourse(0);
    }
  }, [infoTable?.step, infoTable?.stepInfos]);

  useEffect(() => {
    if (showModal) {
      document.body.classList.add("disableOverflow");
    } else {
      document.body.classList.remove("disableOverflow");
    }
  }, [showModal]);

  const handleGetSeatingList = () => {
    if (Array.isArray(infoTable?.timeLineInfo)) {
      return infoTable?.timeLineInfo?.map((item: any) => item?.staffName);
    }
    return [];
  };

  const getInfoStaffBlock = () => {
    if (Array.isArray(infoTable?.timeLineInfo)) {
      return infoTable?.timeLineInfo?.filter(
        (item: any) => item?.block === stepOfCourse
      );
    }
    return [];
  };

  const getInfoStaffNextBlock = () => {
    if (Array.isArray(infoTable?.timeLineInfo)) {
      return infoTable?.timeLineInfo?.filter(
        (item: any) => item?.block === stepOfCourse + 1
      );
    }
    return [];
  };

  const handleUpdateStep = async (currentTime?: number, isAuto?: boolean) => {
    setStepOfCourse(stepOfCourse + 1);
    setOverTime(false);
    setLostTime(false);

    await updateStepOfTableAction.mutate(
      {
        id: infoTable?._id,
        data: {
          step: Number(infoTable?.step) + 1,
          time: currentTime,
          offset: moment().utcOffset(),
          autoNext: isAuto ? 1 : 0,
        },
      },
      {
        onError: (err) => {
          if (!!isOnline) {
            handleErrorMessage(err);
            return;
          }
          const listTableSessionCurrent = queryClient.getQueryData(
            queryKeys.listTableSession
          ) as any;
          if (Array.isArray(listTableSessionCurrent?.data)) {
            const listTableSessionNew = listTableSessionCurrent?.data?.map(
              (item: any) => {
                if (String(item?._id) === String(infoTable?._id)) {
                  const timeRanInfo = item.stepInfos?.find(
                    (info: any) => info.step === item.step
                  );
                  const differTime =
                    timeRanInfo?.time ||
                    (Number((item.tableConfig as any)?.timer) +
                      Number((item.tableConfig as any)?.intervalTime)) *
                      60;
                  let timeLineInfoReal = item.timeLineInfoReal;
                  let timeLineInfoChange;
                  let totalDifferentTime = item.totalDifferentTime + differTime;
                  const currentInTimeLine = timeLineInfoReal?.[
                    item?.step
                  ] as string;
                  const differTimeSecond = -moment().diff(
                    moment(currentInTimeLine, "HH:mm").add(
                      Number((item.tableConfig as any)?.timer) +
                        Number((item.tableConfig as any)?.intervalTime),
                      "m"
                    ),
                    "s"
                  );
                  const differTimeMinutes = Math.ceil(differTimeSecond / 60);
                  if (differTimeMinutes != 0) {
                    timeLineInfoReal = timeLineInfoReal.map(
                      (timeline: any, index: number) => {
                        if (index > Number(item?.step)) {
                          return moment(timeline, "HH:mm")
                            .subtract(differTimeMinutes, "m")
                            .format("HH:mm");
                        }

                        return timeline;
                      }
                    );
                    timeLineInfoReal.push(
                      moment(
                        timeLineInfoReal?.[timeLineInfoReal?.length - 1],
                        "HH:mm"
                      )
                        .add(
                          Number((item.tableConfig as any)?.timer) +
                            Number((item.tableConfig as any)?.intervalTime),
                          "m"
                        )
                        .format("HH:mm")
                    );

                    timeLineInfoChange = item?.timeLineInfo.map(
                      (item: any, index: number) => {
                        if (item?.block === item?.step) {
                          return {
                            ...item,
                            endTime: moment(item?.endTime, "HH:mm")
                              .subtract(differTimeMinutes, "m")
                              .format("HH:mm"),
                          };
                        }

                        if (item?.block >= item?.step + 1) {
                          return {
                            ...item,
                            startTime: moment(item?.startTime, "HH:mm")
                              .subtract(differTimeMinutes, "m")
                              .format("HH:mm"),
                            endTime: moment(item?.endTime, "HH:mm")
                              .subtract(differTimeMinutes, "m")
                              .format("HH:mm"),
                          };
                        }

                        return item;
                      }
                    );
                  }
                  return {
                    ...item,
                    timeLineInfoReal,
                    timelineInfo: timeLineInfoChange,
                    totalDifferentTime,
                    step: Number(item?.step) + 1,
                  };
                }
                return item;
              }
            );
            queryClient.setQueryData(queryKeys.listTableSession, {
              data: listTableSessionNew,
            });
          }
        },
        onSuccess: () => {
          queryClient.invalidateQueries(queryKeys.listStaffDuplicate);
          queryClient.invalidateQueries(queryKeys.listTimeWorkStaff);
        },
      }
    );
  };

  const handleSetOverTime = () => {
    setOverTime(true);
    setLostTime(false);
  };

  const handleSetLostTime = () => {
    setLostTime(true);
  };

  const checkHaveStaffDuplicate = () => {
    const listStaffDuplicate = queryClient.getQueryData(
      queryKeys.listStaffDuplicate
    ) as any;
    const listDuplicate = [] as any[];

    if (
      Array.isArray(listStaffDuplicate?.data) &&
      Array.isArray(infoTable?.timeLineInfo)
    ) {
      listStaffDuplicate?.data?.forEach((item: any) => {
        if (Array.isArray(item?.table)) {
          listDuplicate.push(
            ...item?.table?.map((table: any) => table.tableId)
          );
        }
      });
      return listDuplicate.includes(infoTable?._id);
    }
    return false;
  };

  const checkInLostTime = () => {
    if (infoTable?.stepInfos && Array.isArray(infoTable?.stepInfos)) {
      const infoCurrentStep = infoTable?.stepInfos?.find(
        (item: any) => item?.step === infoTable?.step
      );

      return (
        infoCurrentStep?.time &&
        infoCurrentStep?.time < infoTable?.tableConfig?.intervalTime * 60
      );
    }
    return false;
  };

  const checkStaffDuplicate = (staff: StaffType, nextStep?: boolean) => {
    const listStaffDuplicate = queryClient.getQueryData(
      queryKeys.listStaffDuplicate
    ) as any;
    const stepCheck = Number(infoTable?.step) + (nextStep ? 1 : 0) + 1;
    const timeCheck = infoTable?.timeLineInfoReal?.[stepCheck];

    const combinedTime = moment(infoTable?.dateReal).set({
      hour: parseInt(timeCheck?.split(":")[0], 10),
      minute: parseInt(timeCheck?.split(":")[1], 10),
      second: 0,
      millisecond: 0,
    });
    let isDuplicate = false;
    if (listStaffDuplicate && Array.isArray(listStaffDuplicate?.data)) {
      listStaffDuplicate?.data?.forEach((item: any) => {
        if (item?.staffInfo?.id === staff?.id) {
          item.table?.forEach((table: any) => {
            const combinedTime1 = moment(table?.dateReal).set({
              hour: parseInt(table?.endTime.split(":")[0], 10),
              minute: parseInt(table?.endTime.split(":")[1], 10),
              second: 0,
              millisecond: 0,
            });
            if (
              moment(table.startTime, "HH:mm").isBefore(
                moment(table?.infoTable.startTime, "HH:mm")
              )
            ) {
              combinedTime1.add(1, "day");
            }
            if (
              infoTable?._id === table?.tableId &&
              Number(infoTable?.step) + (nextStep ? 1 : 0) ===
                Number(table?.block) &&
              combinedTime1.isAfter(moment()) &&
              combinedTime.isAfter(moment())
            ) {
              isDuplicate = true;
            }
          });
        }
      });
    }
    return isDuplicate;
  };

  const getStaffInOrderBlock = (block: number) => {
    const listStaff = infoTable?.orderList?.filter(
      (item: any) => item?.index === block
    );
    if (listStaff?.length > 0) {
      const listStaffName = listStaff?.map(
        (item: any) => item?.staff?.staffName
      );

      return listStaffName?.join(", ");
    }
    return "";
  };
  return (
    <>
      {showModal && (
        <ModalSettingTable
          infoTable={infoTable}
          id={id}
          setShowModal={setShowModal}
          countNextBtn={stepOfCourse}
          differTime={infoTable?.differTime || 0}
          showModal={showModal}
        />
      )}
      {!!infoTable?.status ? (
        <div
          className={classNames("takuWrapper", {
            // ["disableOverflow"]: !!showModal,
            [styles.takuMobile]: !!isMobile,
          })}
        >
          <div>
            <div
              className={classNames("taku blue", {
                ["red"]: overtime || getInfoStaffNextBlock().length === 0,
                ["yellow"]: !overtime && (lostTime || checkInLostTime()),
              })}
              // className={`taku ${classNameTaku}`}
              id={infoTable ? infoTable?._id : null}
              onClick={() => {
                if (Number(userPlan) === UserPlan.SubAccount) {
                  return;
                }
                ShowModal();
              }}
            >
              {checkHaveStaffDuplicate() && (
                <div className={classNames("duplicateFlag", {})}>!</div>
              )}
              <div className="takuInfoWrapper">
                <div className="takuNumber">{`${infoTable?.tableConfig?.code}${infoTable?.tableConfig?.no}`}</div>
                <div className="takuInfo takuInfoWithTable">
                  <p className="takuStatus">
                    {`${
                      infoTable?.type === TableSessionType.First
                        ? "初回"
                        : infoTable?.type === TableSessionType.Referral
                        ? "枝フリー"
                        : "同業"
                    }
                  ${infoTable?.tableConfig?.hime}名`}
                  </p>
                  <p className="takuDate">
                    {infoTable?.tableConfig?.startTime}
                    <span>▶</span>
                    {infoTable?.tableConfig?.endTime}
                  </p>{" "}
                  <p className="takuCustomer">
                    {!!infoTable?.customer &&
                      Array.isArray(infoTable?.timeLineInfo) &&
                      infoTable?.timeLineInfo?.length > 0 && (
                        <>{infoTable?.customer}様</>
                      )}
                  </p>
                </div>
              </div>
              <div className="takuStaffWrapper">
                <div className="takuStaffUpper">
                  <p className="now">NOW</p>
                  <ul className="takuStaff">
                    {getInfoStaffBlock()?.map((staff: StaffType, j: number) => (
                      <StaffComponent
                        id={staff.id}
                        staffName={staff?.staffName}
                        // star={staff.star}
                        key={j}
                        disableShowStar={true}
                        disableDragable={true}
                        isDuplicate={checkStaffDuplicate(staff)}
                      />
                    ))}
                  </ul>
                </div>
                <div className="takuStaffBottom">
                  <p className="now">NEXT</p>
                  <ul className="takuStaff">
                    {getInfoStaffNextBlock()?.map(
                      (staff: StaffType, j: number) => (
                        <StaffComponent
                          id={staff.id}
                          staffName={staff?.staffName}
                          // star={staff.star}
                          key={j}
                          disableShowStar={true}
                          disableDragable={true}
                          isDuplicate={checkStaffDuplicate(staff, true)}
                        />
                      )
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <CountdownComponent
              // {...takuSettei[index]}
              timer={infoTable?.tableConfig?.timer}
              setUpdateFlag={() => null}
              seatingList={handleGetSeatingList}
              setSeatingListIndex={handleUpdateStep}
              setDifferTime={() => null}
              intervalTime={infoTable?.tableConfig?.intervalTime}
              infoTable={infoTable}
              step={stepOfCourse}
              handleSetOverTime={handleSetOverTime}
              handleSetLostTime={handleSetLostTime}
              overtime={overtime}
              isLoading={isLoading}
            />
          </div>
          <div className={styles.infoCustomer}>
            {Array.isArray(infoTable?.orderList) &&
              infoTable?.orderList?.length > 0 && (
                <div className="orderList">
                  <div className="title">PHOTO</div>
                  {Array.from({
                    length: infoTable?.tableConfig.hime,
                  })?.map((item: any, index: number) => {
                    if (!!getStaffInOrderBlock(index)) {
                      return (
                        <div>
                          写真 {index + 1}: {getStaffInOrderBlock(index)}
                        </div>
                      );
                    }
                  })}
                </div>
              )}
            {!!infoTable?.memo && (
              <div className="memoContainer">
                <div className="title">MEMO</div>

                <div>{infoTable?.memo} </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          className={classNames("takuWrapper", {
            [styles.takuMobileNoSet]: !!isMobile,
          })}
        >
          <div
            className="taku gray"
            onClick={() => {
              if (Number(userPlan) === UserPlan.SubAccount) {
                return;
              }
              ShowModal();
            }}
          >
            <div className="takuInfoWrapper">
              {/* <div className="takuNumber">{takuId}</div> */}
              <div className="takuInfo">
                <p className="config">設定する</p>
              </div>
            </div>
            <div className="takuStaffWrapper">
              <button className="plus-button">
                <div className="border-radius"></div>
                <div className="plus-button__line plus-button__line--first"></div>
                <div className="plus-button__line plus-button__line--second"></div>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
});
